import React from "react";
import Typewriter from "typewriter-effect";

function Type({ strings }: any) {
  return (
    <Typewriter
      onInit={(typewriter) => {
        typewriter
          .typeString(strings[0])
          .pauseFor(2000000) // pausa 2 segundos no primeiro string
          .deleteAll()
          .callFunction(() => {
            // aqui você pode continuar com os outros strings
          })
          .start();
      }}
      options={{
        autoStart: true,
        loop: true,
      }}
    />
  );
}

export default Type;
